import { UserOptimizer } from '../graphql/generated/graphql';

class IntercomService {
  private getIntercom: () => any;
  private appId: string;
  private isBooted: boolean;

  constructor(getIntercom: () => any, appId: string) {
    this.getIntercom = getIntercom;
    this.appId = appId;
    this.isBooted = false;
  }

  public identify = (user: UserOptimizer) => {
    this.bootOrUpdate({
      app_id: this.appId,
      user_id: user.id,
      name: user.name,
      email: user.email,
      Optimizer: true, // intercom custom field: used for separating user segment
    });
  };

  public anonymize = () => {
    this.bootOrUpdate({
      app_id: this.appId,
    });
  };

  public openNewMessage = (defaultBody?: string) => {
    this.getIntercom()('showNewMessage', defaultBody);
  };

  private bootOrUpdate = (...args: any[]) => {
    this.getIntercom()(this.isBooted ? 'update' : 'boot', ...args);

    this.isBooted = true;
  };
}

export default IntercomService;
